<template>
    <div class="alert alert-warning">
        <i class="fa fa-2x fa-exclamation-triangle d-inline-block mr-2"></i>
        Za prikaz osveženih podatkov je <span v-if="timerVal != 0">po {{timerVal}} sekundah</span> potrebno iskanje ponoviti.
        <div class="mt-3">
            <a class="btn btn-primary text-white" :class="timerVal != 0 ? 'disabled' : ''" @click="repeatSearch()"><i class="fa fa-search"></i> Ponovi iskanje</a>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import axios from 'axios/index';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: 'SolrDelayWarning',
        components: {
            Loading
        },
        data() {
            return {
                isLoading: false,
                timerVal: null
            }
        },
        mounted() {
            const _this = this;
            _this.startCountDownTimer();
        },
        methods: {
            startCountDownTimer() {
                const _this = this;
                _this.timerVal = 20;

                let countDownInterval = setInterval(function(){
                    if(_this.timerVal > 0) {
                        _this.timerVal --;
                    } else {
                        clearInterval(countDownInterval);
                    }
                }, 1000);

            },

            repeatSearch() {
                const _this = this;

                if(_this.timerVal != 0) {
                    return;
                }

                _this.$parent.showSolrDelayWarning = false;
                _this.$parent.submitQuery(true);
            }

        }

    };
</script>


// WEBPACK FOOTER //
// src/components/SolrDelayWarning.vue